"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _echarts = _interopRequireDefault(require("echarts/lib/echarts"));

var _echartsForReact = _interopRequireDefault(require("echarts-for-react"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = require("underscore");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

require("./AnalysisCard.css");

var _CumPerfTable = _interopRequireDefault(require("./Tables/CumPerfTable.js"));

var _DetailsTable = _interopRequireDefault(require("./Tables/DetailsTable.js"));

var _functions = require("../../util/functions");

var _types = require("@babel/types");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CHART_HEIGHT = '350px';
var COLORS = {
  blue: '#0047BB',
  teal: '#2DCCD3',
  grey: '#5B6770',
  orange: '#F68D2E',
  auburn: '#84344E',
  sky: '#00A9E0',
  green: '#658D1B',
  white: '#FFFFFF',
  silver: '#BDC2C6' // Map for plural field names that need conversion to singular

};
var FUND_KEY_MAP = {
  expenseRatiosGross: 'expenseRatioGross',
  assetClasses: 'assetClass',
  categories: 'category',
  wtCategories: 'wtCategory',
  geoFocuses: 'geoFocus',
  ttmDivYieldsOrdinaryIncome: 'ttmDivYieldOrdinaryIncome',
  entities: 'entity',
  expenseRatiosAdjusted: 'expenseRatioAdjusted'
};
var PERFORMANCE_TABLE_TYPES = ['portfolio-performance', 'fund-performance', 'fund-details'];

var AnalysisCard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AnalysisCard, _React$PureComponent);

  function AnalysisCard(props) {
    var _this;

    _classCallCheck(this, AnalysisCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnalysisCard).call(this, props));
    _this.handlePerformanceView = _this.handlePerformanceView.bind(_assertThisInitialized(_this));
    _this.state = {
      cardHovered: false,
      showAllDetails: !_this.props.showDetailsOnHover,
      showPerformanceView: 'portfolio-performance'
    };
    _this.handleScrollToTop = _this.handleScrollToTop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AnalysisCard, [{
    key: "handlePerformanceView",
    value: function handlePerformanceView(type) {
      this.setState({
        showPerformanceView: type
      });
    }
  }, {
    key: "handleScrollToTop",
    value: function handleScrollToTop() {
      var nav = document.getElementById(this.props.topOfAppId);

      if (nav) {
        nav.scrollIntoView({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    } // Render a Line chart with all options

  }, {
    key: "renderLineChart",
    value: function renderLineChart() {
      var _this$props = this.props,
          categoryData = _this$props.categoryData,
          seriesData = _this$props.seriesData,
          categoryIsDate = _this$props.categoryIsDate,
          showChartLabels = _this$props.showChartLabels,
          showAxes = _this$props.showAxes,
          seriesCurrencyLabel = _this$props.seriesCurrencyLabel,
          seriesColor = _this$props.seriesColor,
          isoCode = _this$props.isoCode,
          entityCCY = _this$props.entityCCY;
      var showAllDetails = this.state.showAllDetails;
      var option = {
        xAxis: {
          type: 'category',
          data: categoryIsDate ? categoryData.map(function (category) {
            return (0, _functions.formatShortDate)(category);
          }) : categoryData,
          axisTick: {
            show: true,
            //showAllDetails && showChartLabels,
            lineStyle: {
              color: COLORS.silver
            }
          },
          axisLine: {
            lineStyle: {
              color: COLORS.grey
            }
          },
          axisLabel: {
            show: true,
            //showAllDetails && showChartLabels,
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 10,
            color: COLORS.grey,
            rotate: 45
          },
          show: true //showAllDetails && showAxes,

        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: true,
            //showAllDetails && showChartLabels,
            lineStyle: {
              color: COLORS.silver
            }
          },
          axisLine: {
            lineStyle: {
              color: COLORS.grey
            }
          },
          axisLabel: {
            show: true,
            //showAllDetails && showChartLabels,
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 10,
            color: COLORS.grey,
            formatter: seriesCurrencyLabel ? seriesCurrencyLabel + '{value}' : '{value}'
          },
          splitLine: {
            show: false
          },
          show: true //showAllDetails && showAxes,

        },
        series: seriesData.map(function (series, index) {
          return {
            data: series.data,
            type: 'line',
            symbol: 'none',
            name: series.name,
            lineStyle: {
              color: series.color
            },
            // Show area shading for first series only
            areaStyle: index === 0 ? {
              color: new _echarts.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: seriesColor
              }, {
                offset: 1,
                color: COLORS.white
              }])
            } : null
          };
        }),
        grid: {
          show: false,
          containLabel: true,
          top: 15,
          left: 30,
          right: 30,
          bottom: 30
        },
        legend: {
          data: ['高度(km)与气温(°C)变化关系']
        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var res = params[0].axisValue + '';

            for (var i = 0, l = params.length; i < l; i++) {
              if (!params[i].value) {
                continue;
              }

              res += '<br/>' + '<span style="color:' + seriesData[i].color + ';font-weight:700;">' + params[i].seriesName + '</span>: ' + (seriesCurrencyLabel ? new Intl.NumberFormat(isoCode, {
                style: 'currency',
                currency: entityCCY,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
              }).format(params[i].value) : (0, _functions.formatNumber)(params[i].value, 0));
            }

            return res;
          },
          backgroundColor: '#FFF',
          borderWidth: 1,
          borderColor: COLORS.grey,
          borderRadius: 0,
          textStyle: {
            color: '#5B6770',
            align: 'left',
            fontSize: 10
          }
        }
      };
      return _react.default.createElement("div", {
        className: "chart",
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement(_echartsForReact.default, {
        option: option,
        notMerge: true,
        lazyUpdate: true,
        style: {
          height: CHART_HEIGHT
        }
      }));
    } // Render a Bar chart with all options (horizontal)

  }, {
    key: "renderBarChart",
    value: function renderBarChart() {
      var _this2 = this;

      var _this$props2 = this.props,
          seriesData = _this$props2.seriesData,
          categoryIsDate = _this$props2.categoryIsDate,
          showChartLabels = _this$props2.showChartLabels,
          showAxes = _this$props2.showAxes,
          seriesCurrencyLabel = _this$props2.seriesCurrencyLabel,
          seriesIsPercentage = _this$props2.seriesIsPercentage,
          sliceCategoriesToN = _this$props2.sliceCategoriesToN; // Create new array of sliced data series (choped to 10 categories if necessary and then sum the rest to an 'other' category if required

      var slicedSeries = [];
      seriesData.forEach(function (series, index) {
        var slicedData = _this2.sliceDataSeries(series.data, series.categories, sliceCategoriesToN);

        slicedSeries.push({
          name: series.name,
          color: series.color,
          data: slicedData[0],
          categories: slicedData[1]
        });
      }); // Get distinct categories across all the series (now they've been sliced)
      // This should be in the order of the first series (desc) given we take that
      // one first.

      var distinctCategories = [];
      slicedSeries.forEach(function (series, index) {
        distinctCategories = (0, _underscore.union)(distinctCategories, series.categories);
      }); // Resort the distinct categories by the first (i.e., most important) series' categories (that
      // were already sorted)

      distinctCategories.sort(function (a, b) {
        return slicedSeries[0].categories.indexOf(a) - slicedSeries[0].categories.indexOf(b);
      }); // Get the final series by realigning to the distinct set of categories

      var finalSeries = [];
      seriesData.forEach(function (series, index) {
        finalSeries.push({
          name: series.name,
          color: series.color,
          categories: distinctCategories,
          data: distinctCategories.map(function (category) {
            var weight = series.data[series.categories.indexOf(category)];
            return weight ? weight : 0;
          })
        });
      });
      var showAllDetails = this.state.showAllDetails;
      var option = {
        legend: {
          show: finalSeries.length > 1,
          data: finalSeries.map(function (series) {
            return {
              name: series.name,
              icon: 'rect',
              textStyle: {
                align: 'right',
                fontSize: 8,
                color: COLORS.grey,
                fontWeight: 500
              }
            };
          }),
          orient: 'vertical',
          top: 0,
          right: 10,
          itemWidth: 10,
          itemHeight: 5,
          itemGap: 2
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false,
            //showAllDetails && showChartLabels,
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 10,
            color: COLORS.grey,
            rotate: 45,
            formatter: seriesIsPercentage ? function (value, index) {
              return (0, _functions.formatPercent)(value, 0, true);
            } : '{value}'
          },
          axisTick: {
            show: false,
            //showAllDetails && showChartLabels,
            lineStyle: {
              color: COLORS.silver
            }
          },
          axisLine: {
            lineStyle: {
              color: COLORS.grey
            }
          },
          splitLine: {
            show: false
          },
          show: false //showAllDetails && showAxes,

        },
        yAxis: {
          type: 'category',
          data: categoryIsDate ? finalSeries[0].categories.map(function (category) {
            return (0, _functions.formatShortDate)(category);
          }) : finalSeries[0].categories,
          axisLabel: {
            show: true,
            //showAllDetails && showChartLabels,
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 11,
            color: COLORS.grey,
            formatter: seriesCurrencyLabel ? seriesCurrencyLabel + '{value}' : '{value}'
          },
          axisTick: {
            show: false,
            //showAllDetails && showChartLabels,
            lineStyle: {
              color: COLORS.silver
            }
          },
          axisLine: {
            lineStyle: {
              color: COLORS.grey
            }
          },
          show: true //showAllDetails && showAxes,

        },
        series: finalSeries.map(function (series) {
          return {
            name: series.name,
            data: series.data,
            type: 'bar',
            itemStyle: {
              color: series.color
            },
            areaStyle: {
              color: new _echarts.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: series.color
              }, {
                offset: 1,
                color: COLORS.white
              }])
            },
            cursor: 'default',
            label: {
              show: true,
              position: 'right',
              fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
              fontSize: 11,
              color: COLORS.grey,
              formatter: seriesIsPercentage ? function (params) {
                return (0, _functions.formatPercent)(params.value, 0, true);
              } : '{value}'
            }
          };
        }),
        grid: {
          show: false,
          containLabel: true,
          top: finalSeries.length > 1 ? 25 : 15,
          left: 30,
          right: 35,
          bottom: 30
        }
      };
      return _react.default.createElement("div", {
        className: "chart",
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement(_echartsForReact.default, {
        option: option,
        notMerge: true,
        lazyUpdate: true,
        style: {
          height: CHART_HEIGHT
        }
      }));
    } // Render a Column chart with all options

  }, {
    key: "renderColumnChart",
    value: function renderColumnChart() {
      var _this$props3 = this.props,
          categoryData = _this$props3.categoryData,
          seriesData = _this$props3.seriesData,
          categoryIsDate = _this$props3.categoryIsDate,
          showChartLabels = _this$props3.showChartLabels,
          showAxes = _this$props3.showAxes,
          seriesCurrencyLabel = _this$props3.seriesCurrencyLabel,
          seriesColor = _this$props3.seriesColor;
      var showAllDetails = this.state.showAllDetails;
      var option = {
        xAxis: {
          type: 'category',
          data: categoryIsDate ? categoryData.map(function (category) {
            return (0, _functions.formatShortDate)(category);
          }) : categoryData,
          axisLabel: {
            show: true,
            // showAllDetails && showChartLabels,
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 10,
            color: COLORS.grey,
            rotate: 45
          },
          axisTick: {
            show: false,
            //showAllDetails && showChartLabels,
            lineStyle: {
              color: COLORS.silver
            }
          },
          axisLine: {
            lineStyle: {
              color: COLORS.grey
            }
          },
          show: true //showAllDetails && showAxes,

        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            //showAllDetails && showChartLabels,
            fontFamily: 'Avenir, "Avenir LT 55 Roman", sans-serif',
            fontSize: 10,
            color: COLORS.grey,
            formatter: seriesCurrencyLabel ? seriesCurrencyLabel + '{value}' : '{value}'
          },
          axisTick: {
            show: true,
            //showAllDetails && showChartLabels,
            lineStyle: {
              color: COLORS.silver
            }
          },
          axisLine: {
            lineStyle: {
              color: COLORS.grey
            }
          },
          splitLine: {
            show: false
          },
          show: true //showAllDetails && showAxes,

        },
        series: [{
          data: seriesData,
          type: 'bar',
          itemStyle: {
            color: seriesColor
          },
          areaStyle: {
            color: new _echarts.default.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: seriesColor
            }, {
              offset: 1,
              color: COLORS.white
            }])
          },
          cursor: 'default'
        }],
        grid: {
          show: false,
          containLabel: true,
          top: 15,
          left: 30,
          right: 30,
          bottom: 30
        }
      };
      return _react.default.createElement("div", {
        className: "chart",
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement(_echartsForReact.default, {
        option: option,
        notMerge: true,
        lazyUpdate: true,
        style: {
          height: CHART_HEIGHT
        }
      }));
    } // Render a TreeMap with all options

  }, {
    key: "renderTreemap",
    value: function renderTreemap() {
      var seriesData = this.props.seriesData;
      var option = {
        tooltip: {
          backgroundColor: '#FFF',
          borderWidth: 1,
          borderColor: '#5A6770',
          borderRadius: 3,
          padding: 10,
          formatter: '<b>{b}</b> {c}%<br />Click to open in Fund Comparison',
          textStyle: {
            color: '#5A6770',
            align: 'center',
            fontSize: 12
          }
        },
        series: [{
          data: seriesData,
          type: 'treemap',
          colorMappingBy: 'id',
          //dimensions: ['value', 'formattedValue'],
          roam: false,
          nodeClick: 'link',
          breadcrumb: {
            show: false
          },
          silent: false,
          left: 50,
          top: 10,
          bottom: 0,
          width: '80%',
          height: '80%',
          itemStyle: {
            gapWidth: 2
          },
          color: [COLORS.blue, COLORS.teal, COLORS.grey, COLORS.orange, COLORS.sky, COLORS.green]
        }]
      };
      return _react.default.createElement("div", {
        className: "chart",
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement(_echartsForReact.default, {
        option: option,
        notMerge: true,
        lazyUpdate: true,
        style: {
          height: CHART_HEIGHT,
          maxWidth: '500px'
        }
      }));
    } // Render a table with Key Metrics

  }, {
    key: "renderKeyMetrics",
    value: function renderKeyMetrics() {
      var seriesData = this.props.seriesData;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('chart', this.props.onChartClick ? 'clickable' : ''),
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement("div", {
        className: "keymetrics"
      }, seriesData ? seriesData.map(function (metric, index) {
        return _react.default.createElement("div", {
          key: metric.name,
          className: (0, _classnames.default)('metric-row', index === seriesData.length - 1 ? 'last' : '', metric.clickable ? 'scroll-to' : ''),
          onClick: function onClick(event) {
            var chart = document.getElementById(metric.name + '-chart');

            if (chart) {
              chart.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }
        }, _react.default.createElement("div", {
          className: "metric-title"
        }, metric.title), metric.value2 && _react.default.createElement("div", {
          className: 'value2 ' + (metric.boldValue === metric.value2 ? 'value-bold' : '')
        }, metric.value2, _react.default.createElement("span", {
          className: "symbol"
        }, metric.symbol)), _react.default.createElement("div", {
          className: 'value ' + (metric.boldValue === metric.value ? 'value-bold' : '')
        }, metric.value, _react.default.createElement("span", {
          className: "symbol"
        }, metric.symbol)), _react.default.createElement("div", {
          className: "metric-desc"
        }, _react.default.createElement("div", {
          className: "desc"
        }, metric.description), _react.default.createElement("div", {
          className: "metric-tooltip"
        }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          "data-tip": true,
          "data-for": metric.name + '-desc',
          icon: "question-circle",
          size: "sm"
        })), _react.default.createElement(_reactTooltip.default, {
          id: metric.name + '-desc',
          type: "light",
          className: "tooltip",
          effect: "float"
        }, metric.tooltip)));
      }) : null));
    } // Render info card

  }, {
    key: "renderInfoText",
    value: function renderInfoText() {
      var infoText = this.props.infoText;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('chart', this.props.onChartClick ? 'clickable' : ''),
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement("div", {
        className: "info-text",
        dangerouslySetInnerHTML: {
          __html: infoText
        }
      }));
    } // Pivot a holdings based data set into an array of funds

  }, {
    key: "pivotData",
    value: function pivotData(data) {
      var newData = []; // Assumes data is a holdings object. User tickers as array to loop over

      data.tickers.forEach(function (ticker, index) {
        var newFund = {};
        Object.keys(data).forEach(function (key) {
          // Get the new key name - replace it directly if there is a map, or remove the last 's'
          if (Array.isArray(data[key])) {
            // console.log(key + ',');
            // console.log('Writing ' + ticker + ' for key ' + key + ' with data ' + data[key][index]);
            var newKeyName = FUND_KEY_MAP[key] ? FUND_KEY_MAP[key] : key.replace(/s$/, '');
            newFund[newKeyName] = data[key][index];
          } else {
            newFund[key] = data[key];
          }
        });
        newData.push(newFund);
      });
      return newData;
    }
  }, {
    key: "renderPerformanceTable",
    value: function renderPerformanceTable() {
      var _this3 = this;

      var _this$props4 = this.props,
          personalStrategy = _this$props4.personalStrategy,
          translationDictionary = _this$props4.translationDictionary;
      var showPerformanceView = this.state.showPerformanceView; // If the holdings is an array then it should already be a funds array list. If not
      // its holdings so pivot the data

      var fundData = personalStrategy.latestAnalysis.holdings.length > 1 ? personalStrategy.latestAnalysis.holdings : this.pivotData(personalStrategy.latestAnalysis.holdings[0]);
      var portfolioPerformance = [{
        stdPerformance: personalStrategy.latestAnalysis.stdPerformance,
        name: personalStrategy.name
      }]; // If a benchmark exists then add to the portfolio performance

      if (personalStrategy.latestAnalysis.benchmarks && personalStrategy.latestAnalysis.benchmarks.length > 0) {
        portfolioPerformance.push({
          stdPerformance: personalStrategy.latestAnalysis.benchmarks[0].stdPerformance,
          name: personalStrategy.latestAnalysis.benchmarks[0].name
        });
      }

      var tableToShow;

      switch (showPerformanceView) {
        case 'portfolio-performance':
          tableToShow = _react.default.createElement(_CumPerfTable.default, {
            data: portfolioPerformance,
            translationDictionary: translationDictionary,
            showTitle: false,
            showCommonPeriod: true,
            commonPeriodStart: personalStrategy.latestAnalysis.commonPeriodStart,
            commonPeriodEnd: personalStrategy.latestAnalysis.commonPeriodEnd,
            isPortfolio: true
          });
          break;

        case 'fund-performance':
          tableToShow = _react.default.createElement(_CumPerfTable.default, {
            data: fundData,
            translationDictionary: translationDictionary,
            showTitle: false,
            showCommonPeriod: false
          });
          break;

        case 'fund-details':
          tableToShow = _react.default.createElement(_DetailsTable.default, {
            data: fundData,
            translationDictionary: translationDictionary,
            showTitle: false
          });
          break;

        default:
          tableToShow = null;
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)('chart', this.props.onChartClick ? 'clickable' : ''),
        style: {
          minHeight: this.props.minChartHeight
        },
        onClick: this.props.onChartClick
      }, _react.default.createElement("div", {
        className: "align-right"
      }, PERFORMANCE_TABLE_TYPES.map(function (type) {
        return _react.default.createElement("button", {
          key: type,
          onClick: _this3.handlePerformanceView.bind(_this3, type),
          className: (0, _classnames.default)(showPerformanceView === type ? 'active' : 'not-active')
        }, translationDictionary.t(type));
      })), tableToShow);
    } // Handle a hover over the card

  }, {
    key: "setCardHovered",
    value: function setCardHovered() {
      var currentHoverState = this.state.cardHovered;
      this.setState({
        cardHovered: !currentHoverState,
        // If the card is set up to only reveal details on hover then check if 
        // details should be shown
        showAllDetails: !this.props.showDetailsOnHover || this.props.showDetailsOnHover && !currentHoverState
      });
    }
    /**
     * Order a set of category data from big to small then keep the 
    /* top n of those. Finally sum the rest and label as 'Other'
     * @param {*} seriesData 
     * @param {*} categoryData 
     * @param {*} numberOfItemsToKeep 
     */

  }, {
    key: "sliceDataSeries",
    value: function sliceDataSeries(seriesData, categoryData, numberOfItemsToKeep) {
      // Zip up the data together
      var zippedData = (0, _underscore.zip)(seriesData, categoryData); // Sort the data by the series (values)

      var orderedData = zippedData.sort(function (a, b) {
        return b[0] - a[0];
      });

      if (numberOfItemsToKeep) {
        // Take the top n
        var topData = orderedData.slice(0, numberOfItemsToKeep); // Take the remaining 

        var otherData = orderedData.slice(numberOfItemsToKeep); // Check if there is anything else to combine

        if (otherData.length > 0) {
          // Sum up the series data element of the remaining elements
          var totalOther = otherData.map(function (elem) {
            return elem[0];
          }).reduce(function sumofArray(sum, num) {
            return sum + num;
          }); // Add the other to the remaining

          topData.push([totalOther, 'Other']);
        } // Unzip it all


        orderedData = topData;
      } // Unzip it all


      var newData = (0, _underscore.unzip)(orderedData); // Return it as an array - first element the series values, second the categories

      return [newData[0].reverse(), newData[1].reverse()];
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props5 = this.props,
          chartType = _this$props5.chartType,
          heroNumber = _this$props5.heroNumber,
          heroTitle = _this$props5.heroTitle,
          heroNumberIsPercent = _this$props5.heroNumberIsPercent,
          chartTitle = _this$props5.chartTitle,
          footnoteText = _this$props5.footnoteText,
          showDetailsOnHover = _this$props5.showDetailsOnHover,
          cardTitle = _this$props5.cardTitle,
          idOfCard = _this$props5.idOfCard,
          metricComparisonNames = _this$props5.metricComparisonNames,
          topOfAppId = _this$props5.topOfAppId;
      var _this$state = this.state,
          showAllDetails = _this$state.showAllDetails,
          cardHovered = _this$state.cardHovered;
      var chart;

      switch (chartType) {
        case 'line':
          chart = this.renderLineChart();
          break;

        case 'bar':
          chart = this.renderBarChart();
          break;

        case 'treemap':
          chart = this.renderTreemap();
          break;

        case 'column':
          chart = this.renderColumnChart();
          break;

        case 'keymetrics':
          chart = this.renderKeyMetrics();
          break;

        case 'performancetable':
          chart = this.renderPerformanceTable();
          break;

        case 'infotext':
          chart = this.renderInfoText();
          break;

        default:
          chart = _react.default.createElement("div", null, "No Chart");
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)('analysis-card', {
          'no-shrink-height': cardHovered && showDetailsOnHover && heroNumber
        }),
        onMouseEnter: function onMouseEnter() {
          return _this4.setCardHovered();
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.setCardHovered();
        },
        id: idOfCard
      }, _react.default.createElement("div", {
        className: "card-title"
      }, cardTitle ? cardTitle : null), topOfAppId && _react.default.createElement("div", {
        className: "up-arrow",
        onClick: this.handleScrollToTop
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: "chevron-up",
        size: "sm"
      })), heroTitle ? _react.default.createElement("div", {
        className: "hero-title",
        dangerouslySetInnerHTML: {
          __html: heroTitle
        }
      }) : null, heroNumber ? _react.default.createElement("div", {
        className: "hero-number"
      }, _react.default.createElement("span", null, heroNumberIsPercent ? (0, _functions.formatPercent)(heroNumber, 1) : heroNumber)) : null, _react.default.createElement("div", {
        className: "chart-title"
      }, chartTitle ? chartTitle : null), metricComparisonNames && _react.default.createElement("div", {
        className: "metrics-header"
      }, _react.default.createElement("div", {
        className: "metrics-header-name"
      }, metricComparisonNames[0]), _react.default.createElement("div", {
        className: "metrics-header-name2"
      }, metricComparisonNames[1])), chart, footnoteText && showAllDetails ? _react.default.createElement("div", {
        className: "chart-footnote"
      }, (0, _reactStringReplace.default)(footnoteText, '<br/>', function (match) {
        return _react.default.createElement("br", {
          key: Math.random()
        });
      })) : null);
    }
  }]);

  return AnalysisCard;
}(_react.default.PureComponent);

exports.default = AnalysisCard;

_defineProperty(AnalysisCard, "defaultProps", {
  chartType: 'bar',
  showChartLabels: true,
  showLegend: true,
  showGrid: true,
  showAxes: true,
  categoryIsDate: true,
  heroNumberIsPercent: true,
  shrinkHeight: true,
  showDetailsOnHover: false,
  seriesColor: COLORS.blue,
  seriesIsPercentage: false,
  isoCode: 'en-US',
  entityCCY: 'USD',
  topOfAppId: 'top-of-app'
});

AnalysisCard.propTypes = {
  /**
   * Type of chart to be rendered
   */
  chartType: _propTypes.default.string,

  /**
   * Required - ID of chart so it can be easily scrolled to
   */
  idOfCard: _propTypes.default.string.isRequired,

  /**
   * Required - ID of top of app used for scrolling back to top
   */
  topOfAppId: _propTypes.default.string.isRequired,

  /**
   * Top title of the card
   */
  cardTitle: _propTypes.default.string,

  /**
   * Array of categories to be used in the chart
   */
  categoryData: _propTypes.default.array,

  /**
   * Check if the category contains a date
   */
  categoryIsDate: _propTypes.default.bool,

  /**
   * Array of series dictionaries each containing the 
   * echart series name and data. 
   */
  seriesData: _propTypes.default.array,

  /**
   * PersonalStrategy object - only used for Performance table as fields are needed
   * from all over the place
   */
  personalStrategy: _propTypes.default.object,

  /**
   * Footnote text to be placed under the chart
   */
  footnoteText: _propTypes.default.string,

  /**
   * Hero number for display above the chart (optional)
   */
  heroNumber: _propTypes.default.number,

  /**
   * Hero title for display above the Hero number
   */
  heroTitle: _propTypes.default.string,

  /**
   * Hero tooltip for hover (e.g., common period dates)
   */
  heroTooltip: _propTypes.default.string,

  /**
   * Format the hero number as a percentage
   */
  heroNumberIsPercent: _propTypes.default.bool,

  /**
   * Show chart labels (default is true). Will remove all ticks and labels if false
   */
  showChartLabels: _propTypes.default.bool,

  /**
   * Show legend (default is true)
   */
  showLegend: _propTypes.default.bool,

  /**
   * Show Grid (default is true)
   */
  showGrid: _propTypes.default.bool,

  /**
   * Show Axes (default is true)
   */
  showAxes: _propTypes.default.bool,

  /**
   * Currency label for series
   */
  seriesCurrencyLabel: _propTypes.default.string,

  /**
   * Callback function if user clicks on the chart
   */
  onChartClick: _propTypes.default.func,

  /**
   * Remove spacing if the titles and footnotes aren't being shown. Used when
   * hovering on an adjacent chart. IF false then will never shrink
   */
  shrinkHeight: _propTypes.default.bool,

  /**
   * Force the card to show titles of chart, footnote, and other things on hover
   */
  showDetailsOnHover: _propTypes.default.bool,

  /**
   * Optional parameter for color of the series in a chart
   */
  seriesColor: _propTypes.default.string,

  /**
   * Optional parameter to format the series as a percentage if needed
   */
  seriesIsPercentage: _propTypes.default.bool,

  /**
   * Optional prop to slice the category array to a given number with the rest as 'Other'
   */
  sliceCategoriesToN: _propTypes.default.number,

  /**
   * Translation dictionary (i18) - needed for tables
   */
  translationDictionary: _propTypes.default.object,

  /**
   * Optional parameter isoCode of chart
   */
  isoCode: _propTypes.default.string,

  /**
   * Optional parameter Currency of chart - used for formatting
   */
  entityCCY: _propTypes.default.string
};